import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { landingContent } from "../../data/landingContent";
import { SearchHandleForm } from "./SearchHandleForm";
import { getAvatarUrl } from "../../utils/avatars";

function LiveIndicator() {
  const [count, setCount] = useState(142);
  const { hero } = landingContent;

  useEffect(() => {
    const id = setInterval(() => {
      setCount((c) => c + Math.floor(Math.random() * 11) - 5);
    }, 7000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="st-live-indicator st-fade-up st-fade-up-d5">
      <span className="st-live-dot">
        <span className="st-live-dot-ping" />
        <span className="st-live-dot-core" />
      </span>
      <span className="st-live-text">
        <strong>{Math.max(80, count)}</strong> {hero.liveText}
      </span>
    </div>
  );
}

const PROOF_AVATARS = [
  { initials: "MR", bg: "#FF6B9D", isImage: true, url: getAvatarUrl("any", 0) },
  { initials: "JT", bg: "#C084FC", isImage: true, url: getAvatarUrl("any", 1) },
  { initials: "AL", bg: "#60A5FA", isImage: true, url: getAvatarUrl("any", 2) },
  { initials: "SP", bg: "#34D399", isImage: true, url: getAvatarUrl("any", 3) },
  { initials: "+", bg: "#ff6b8a", isImage: false },
];

export function HeroSection() {
  const { hero } = landingContent;

  return (
    <section id="top" className="st-hero" aria-label="Hero">
      {/* Floating blobs */}
      <div className="st-hero-blob st-hero-blob-1" aria-hidden="true" />
      <div className="st-hero-blob st-hero-blob-2" aria-hidden="true" />
      <div className="st-hero-blob st-hero-blob-3" aria-hidden="true" />

      <div className="st-container" style={{ position: "relative", zIndex: 1 }}>
        <div className="st-hero-copy">

          {/* Badge with dual-shadow offset */}
          <div className="st-fade-up" style={{ marginBottom: "20px" }}>
            <div className="st-hero-badge-wrapper">
              <div className="st-hero-badge">
                <svg viewBox="0 0 24 24" width="14" height="14" fill="white" aria-hidden="true">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.88-2.88 2.89 2.89 0 012.88-2.88c.28 0 .56.04.81.13v-3.5a6.37 6.37 0 00-.81-.05A6.34 6.34 0 003.15 15.3a6.34 6.34 0 0010.25 4.96 6.34 6.34 0 001.88-4.51V9.4a8.16 8.16 0 004.31 1.23V7.18a4.85 4.85 0 01-1-.49z" />
                </svg>
                {hero.tiktokBadge}
              </div>
            </div>
          </div>

          <h1 className="st-fade-up st-fade-up-d1">{hero.title}</h1>

          <p className="st-hero-subtitle st-fade-up st-fade-up-d2">
            {hero.subtitle}
          </p>

          {/* Search */}
          <div className="st-search-wrapper st-fade-up st-fade-up-d3">
            <SearchHandleForm
              placeholder={hero.inputPlaceholder}
              ctaLabel={hero.ctaLabel}
              autoFocus
              typewriterExamples={[]}
            />

            {/* Trust chips */}
            <div className="st-hero-helper-chips">
              {hero.trustBullets.map((bullet, i) => (
                <span key={i} className="st-hero-chip">
                  <Check size={12} strokeWidth={3} />
                  {bullet}
                </span>
              ))}
            </div>

            <p className="st-hero-microcopy">{hero.helperText}</p>
          </div>

          {/* Social proof pill + live indicator */}
          <div
            className="st-fade-up st-fade-up-d4"
            style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", marginTop: "20px" }}
          >
            <div className="st-hero-proof-pill">
              <div className="st-hero-proof-avatars">
                {PROOF_AVATARS.map((a, i) => (
                  <div
                    key={i}
                    className="st-hero-proof-avatar"
                    style={{ background: a.isImage ? "none" : a.bg }}
                    aria-hidden="true"
                  >
                    {a.isImage ? (
                      <img
                        src={a.url}
                        alt=""
                        style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover", display: "block" }}
                      />
                    ) : (
                      a.initials
                    )}
                  </div>
                ))}
              </div>
              <span className="st-hero-proof-text">{hero.socialProof}</span>
            </div>

            <LiveIndicator />
          </div>

        </div>
      </div>
    </section>
  );
}
